(function($, undefined) {
	
	'use strict';
	
	var init = function () {
		$('.notifications-page .single-notification.highlight').on('click', onSetNotificationAsRead);
		
		
	};
	
	
	var onSetNotificationAsRead = function(e) {
		e.preventDefault();
		var btn = $(this);
		setNotificationAsRead(btn.attr('data-id'), function(response) {
			if (response.indexOf('success') !== -1) {
				btn.removeClass("highlight");
				btn.unbind();
				updateHeaderCounter();
			}
		});
	};
	
	var updateHeaderCounter = function(){
		var icon = $(".header-icon-link");
		if(icon.length !== 0){
			icon.each(function () {
				var i = $(this).find(".notification-count");
				var nbr = i.text();
				var newNbr = parseInt(nbr) - 1;
				i.empty();
				i.text(newNbr);
				if (newNbr === 0) {
					$(this).find(".notification-count-ctn").hide();
				}
			});
		}
	};
	
	/**
	 * Sends a notification on the website, and if specified, as sms and/or as email.
	 * The label is the key of a notification label, which text can have custom values.
	 * e.g.: "%1 a modfié le contenu de la visite du %2 à %3 avec %4"
	 *		^ dans ce cas, values=Serge,20 janvier,21h30,Sergine
	 * 
	 * @param   label 		 the label which contains the notification text (with %1%, %2%, %3%... for custom values)
	 * @param   userIds		 list of comma separated USER ids to which to send the notification (can be just 1)
	 * @param   personIds	 list of comma separated PERSON ids to which to send the notification (can be just 1)
	 * @param   types		the notification type (list of comma separated values, can be [email,sms])
	 * @param   values  	 the custom values of the label
	 * @param   category 	 the category of the notification (automatically set with the data below)
	 * @param 	fields		 an object containing the values of the extra fields for the notification (field7...12)
	 * @param   sendToAdmin  send the notification to all admins from the group "receiveNotifications"
	 * @param   callback    callback function when the ajax call is completed
	 * @param   sendEmail   initial parameter to include sending emails with the notification
	 * 
	 * Sinon, on peut ajouter un call à FormsUtil.notify(label, sendSMS, userIds...) n'importe où dans java
	 */
	var sendNotification = function(label, userIds = null, personIds = null, types = "", values = "", category = "", fields = {}, sendToAdmin = false, callback = () => {}, sendEmail = true) {
		types = types.toLowerCase();
		var params = {
			ajax: true,
			label: label,
			values: values,
			field7: category,
			perPerson: true,
			sendEmail: sendEmail,
			splitChar: '\\*\\|\\|\\|\\*'
		};
		if (userIds != null) {
			params.userIds = userIds;
		}
		if (personIds != null) {
			params.personIds = personIds;
		}
		if (types.indexOf('sms') !== -1) {
			params.sendSMS = true;
		}
		if (types.indexOf('email') !== -1) {
			params.sendEmail = true;
		}
		if (sendToAdmin) {
			params.admin = true;
		}
		for (var key in fields) {
			if (fields.hasOwnProperty(key) && /^field([89]|10|11|12)$/.test(key)) {
				params[key] = fields[key];
			}
		}
		$.ajax({
			url: "/action/createNotification",
			method: "post",
			data: params,
			complete: function(response) { // Une erreur fait que ça retourne toujours dans le "error" de ajax, donc on doit laisser ça à complete
				callback(response.reponseText);
			}
		});
	};
    
	var sendNotificationPerson = function (personId, notifKey, values, callback = () => {}, fields = {}, sendEmail = true) {
		if (NOTIF_KEYS.hasOwnProperty(notifKey)) {
            var strValues = values instanceof Array ? values.join('*|||*') : values;
			var types = getNotificationsPreferences(NOTIF_KEYS[notifKey], personId);
			sendNotification(NOTIF_KEYS[notifKey].label, null, personId, types, strValues, NOTIF_KEYS[notifKey].category.id, fields, false, callback, sendEmail);
		} else {
			callback("error: notification key does not exist");
		}
	};
    
	var sendMultipleNotificationsUsers = function(userIds, notifKey, values, callback = () => {}) {
		if (userIds.length === 0) {
			return callback();
		}
        var idsArray = !(userIds instanceof Array) ? userIds.split(',') : userIds;
		var userId = idsArray[0];
		sendNotificationUser(userId, notifKey, values, function() {
			if (idsArray.length > 0) {
				sendMultipleNotificationsUsers(idsArray.slice(1), notifKey, values, callback);
			} else {
				callback();
			}
		});
	};
    
	var sendMultipleNotificationsPersons = function(personIds, notifKey, values, callback = () => {}, fields = {}) {
        var idsArray = !(personIds instanceof Array) ? personIds.split(',') : personIds;
		var personId = idsArray[0];
		sendNotificationPerson(personId, notifKey, values, function() {
			if (idsArray.length > 0) {
				sendMultipleNotificationsPersons(idsArray.slice(1), notifKey, values, callback, fields);
			} else {
				callback();
			}
		}, fields);
	};
    
	var sendMultipleNotificationsPersonsDifferentData = function(personIds, notifKey, valuesArray, callback = () => {}, fieldsArray = []) {
        var idsArray = !(personIds instanceof Array) ? personIds.split(',') : personIds;
		var personId = idsArray[0];
		var values = valuesArray[0];
		var fields = fieldsArray[0];
		sendNotificationPerson(personId, notifKey, values, function() {
			if (idsArray.length > 0) {
				sendMultipleNotificationsPersonsDifferentData(idsArray.slice(1), notifKey, valuesArray.slice(1), callback, fieldsArray.slice(1));
			} else {
				callback();
			}
		}, fields);
	};
	
	var setNotificationAsRead = function(id, callback = () => {}) {
		$.ajax({
			url: "/action/createNotification",
			method: "post",
			data: {
				id: id,
				read: "true"
			},
			complete: function(response) {
				callback(response.responseText);
			}
		});
	};
    
	var getNotificationsPreferences = function (notif, id) {
//		if (notif.category.hasPreferences) {
//			var notifPreferencesNodeText = $('.notifications-preferences-info').find('.preference[data-category=' + notif.category.id + "][data-person-id=" + id + "]").text();
//			return notifPreferencesNodeText !== "none" ? notifPreferencesNodeText : notif.defaultTypes;
//		} else {
			return notif.defaultTypes;
//		}
	};
    
	$(window).ready(init);
	
	Fw.component.export('notificationUtils', {
		sendNotification,
		sendNotificationPerson,
		sendMultipleNotificationsUsers,
		sendMultipleNotificationsPersons,
		sendMultipleNotificationsPersonsDifferentData,
		setNotificationAsRead
	});
	
})(jQuery);


const NOTIF_CATEGORIES = {
	"MESSAGE": {
		"id": "messagerie"
	},
	"AUDITION": {
		"id": "audition"
	}
};
const NOTIF_KEYS = {
	"NEW_MESSAGE": { //Values : nom de la personne qui envoie le message
		"label": "notification-messagerie-new-message", 
		"category": NOTIF_CATEGORIES.MESSAGE,
		"defaultTypes": ""
	},
	"AUDITION_EDIT": { // values: nom de l'audition, lien de l'audition
		"label": "notification-audition-edit", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AGENCY": { // values: Nom de l'audition, lien vers l'audition
		"label": "notification-audition-request-agency", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AGENCY_FOR_ARTIST": { // values: Nom de l'audition, nom de l'artiste, lien vers l'audition + param
		"label": "notification-audition-request-agency-for-artist", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST": { // values: Nom de l'audition, lien vers l'audition 
		"label": "notification-audition-request-artist", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_REVIEW": { // values: Nom de l'audition, lien vers l'audition
		"label": "notification-audition-request-artist-edit", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"APPLICATION_SUBMITTED": { // values: Nom de l'audition, URL de l'audition
		"label": "notification-audition-submitted", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_SELECTED": { // values: Nom de l'audition, URL de l'audition
        // retenu - recommande
		"label": "notification-audition-artist-selected", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_SELECTED_AGENCY": { // values: Nom de l'audition, URL de l'audition
        // retenu - recommande
		"label": "notification-audition-agency-selected", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_NOT_SELECTED": { // values: Nom de l'audition, URL de l'audition
        // aucun choix
		"label": "notification-audition-artist-not-selected", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_NOT_SELECTED_AGENCY": { // values: Nom de l'audition, URL de l'audition
        // aucun choix
		"label": "notification-audition-agency-not-selected", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_SELECTED_FINAL": { // values: Nom de l'audition, URL de l'audition
        // choisi
		"label": "notification-audition-artist-selected-final", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_SELECTED_FINAL_AGENCY": { // values: Nom de l'audition, URL de l'audition
        // choisi
		"label": "notification-audition-agency-selected-final", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AGENT_APPLICATION_REVIEW": { // values: Nom de l'artiste, Nom de l'audition, lien vers l'application, URL de l'audition
		"label": "notification-audition-agent-application-review", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_CHERCHEUR_APPLICATION_SUBMITTED": { // values: Nom de l'artiste, Nom de l'audition, URL de l'audition
		"label": "notification-audition-chercheur-application-submitted", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
 //	"AUDITION_CLIENT_CHOICE": { // values:  Nom de l'audition, URL de l'audition
	// 	"label": "notification-audition-client-choice", 
	// 	"category": NOTIF_CATEGORIES.AUDITION,
	// 	"defaultTypes": ""
	// },
	"AUDITION_CLOSED": { // values:  Nom de l'audition
		"label": "notification-audition-closed", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
 //	"AUDITION_ARTIST_ACCEPTED": { // values:  Nom de l'artiste, Nom de l'audition, URL de l'audition
	// 	"label": "notification-audition-participate", 
	// 	"category": NOTIF_CATEGORIES.AUDITION,
	// 	"defaultTypes": ""
	// },
	// "AUDITION_ARTIST_ACCEPTED_TO_RESEARCHER": { // values:  Nom de l'artiste, Nom de l'audition, URL de l'audition
	// 	"label": "notification-audition-participate-to-researcher", 
	// 	"category": NOTIF_CATEGORIES.AUDITION,
	// 	"defaultTypes": ""
	// },
	"AUDITION_ARTIST_REFUSED": { // values:  Nom de l'artiste, Nom de l'audition, URL de l'audition
		"label": "notification-audition-refuse", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_REFUSED_TO_RESEARCHER": { // values:  Nom de l'artiste, Nom de l'audition, URL de l'audition
		"label": "notification-audition-refuse-to-researcher", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AGENCY_REFUSED_TO_RESEARCHER": { // values:  Nom de l'agence, Nom de l'audition, URL de l'audition
		"label": "notification-audition-refuse-agency-to-researcher", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_NEW_COMMENT": { // values:  Nom de l'audition, Nom de l'audition, URL de l'audition
		"label": "notification-audition-new-comment", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AUTONOMOUS_ARTIST_TO_AGENT": { // values:  Nom de l'artiste, Nom de l'audition
		"label": "notification-audition-autonomous-artist-submit-to-agent", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_NEW_COMMENT_PARTNER": { // values:  Nom de l'audition, URL de l'audition
		"label": "notification-audition-new-comment-partner", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_NEW_COMMENT_CLIENT": { // values:  Nom de l'audition, URL de l'audition
		"label": "notification-audition-new-comment-client", 
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	}
};
//notificationUtils = Fw.component.models().notificationUtils; 

//notificationUtils.sendNotificationPerson("ID DE LA PERSONNE A QUI ENVOYER LE SMS", "NEW_MESSAGE", "NOM DE LA PERSONNE QUI ENVOIE LE MESSAGE", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DES LA PERSONNE A QUI ENVOYER LE SMS", "AUDITION_EDIT", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DES AGENCES A QUI ENVOYER LE SMS", "AUDITION_AGENCY", "NOM DE L'AUDITION,LIEN VERS L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DES ARTISTES A QUI ENVOYER LE SMS", "AUDITION_ARTIST", "NOM DE L'AUDITION,LIEN VERS L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'ARTISTE A QUI ENVOYER LE SMS", "AUDITION_ARTIST_REVIEW", "NOM DE L'AUDITION,LIEN VERS L'APPLICATION � L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'ARTISTE A QUI ENVOYER LE SMS", "APPLICATION_SUBMITTED", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'ARTISTE A QUI ENVOYER LE SMS", "AUDITION_ARTIST_SELECTED", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'ARTISTE A QUI ENVOYER LE SMS", "AUDITION_ARTIST_NOT_SELECTED", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'AGENT A QUI ENVOYER LE SMS", "AUDITION_AGENT_APPLICATION_REVIEW", "NOM DE L'ARTISTE,NOM DE L'AUDITION, LIEN VERS L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DU CHERCHEUR A QUI ENVOYER LE SMS", "AUDITION_CHERCHEUR_APPLICATION_SUBMITTED", "NOM DE L'ARTISTE,NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DU CHERCHEUR A QUI ENVOYER LE SMS", "AUDITION_CLIENT_CHOICE", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DES PARTICIPANTS", "AUDITION_CLOSED", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
